<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="出账" name="list">
				<div class="content-box">
					<div class="operator">
						<div class="operator-col">
							<el-button size="mini" type="primary" @click="handleCreate()" v-loading="loadings.create">新建</el-button>
						</div>
						<div class="operator-col">
							<hispickup v-model="filterHisDate" @change="refreshTable('listTable')"></hispickup>
						</div>
            <div class="operator-col">
              <warehouse-input v-model="filterWarehouse" @change="refreshTable('listTable')"></warehouse-input>
            </div>
						<div class="operator-col">
							<enum-filter
								size="mini"
								v-model="filterType.index"
								placeholder="分类"
								suffix-icon="el-icon-caret-bottom"
								clearable
								data-model-name="Cashflow"
								field="type"
							></enum-filter>
						</div>
						<div class="operator-col">
							<enum-filter
								size="mini"
								v-model="filterPayMethod.index"
								placeholder="支付方式"
								suffix-icon="el-icon-caret-bottom"
								clearable
								data-model-name="Cashflow"
								field="pay_method"
							></enum-filter>
						</div>
						<div class="operator-col">
							<bool-filter
								size="mini"
								v-model="filterConfirmed.value"
								suffix-icon="el-icon-search"
								clearable
								data-model-name="Cashflow"
								field="has_confirm"
								field-name="已确认"
							></bool-filter>
						</div>
						<div class="operator-col">
							<supplier-input v-model="filterSupplier" @change="refreshTable('listTable')"></supplier-input>
						</div>
					</div>
					<sum-table
						ref="sumTable"
						:data-model="editorDataModel"
						:date-filter="filterHisDate"
						:search-filter="filterTableSearch"
						:kv-filter="kvFilter"
            :warehouse-filter="filterWarehouse"
						:fields="cashSumFields"
					></sum-table>
					<curd-table
						ref="listTable"
						:data-model="editorDataModel"
						:fields="tableFields"
						:expand-fields="cashTableFieldsExpand"
						:kv-filter="kvFilter"
            :warehouse-filter="filterWarehouse"
						:date-filter="filterHisDate"
						@doedit="handleEdit($event)"
						:is-selectable="true"
						:show-summary="true"
						:batch-ops="batchOps"
						@click-batch-op="handleClickBatchOp"
					>
						<template slot="listOp" slot-scope="scope">
							<el-button size="mini" type="text" @click="goInfo(scope.row)">订单详情</el-button>
							<el-button
								size="mini"
								type="text"
								@click="handleEdit(scope.row._id)"
								v-if="userPrivilegeMapping[62]"
							>编辑</el-button>
							<el-button
								size="mini"
								type="text"
								@click="doHasConfirm(scope.row._id)"
								v-if="!scope.row.has_confirm && userPrivilegeMapping[61]"
							>已审核</el-button>
						</template>
					</curd-table>
				</div>
			</el-tab-pane>
		</el-tabs>
		<cash-editor
			:show.sync="editorVisible"
			:record-id="recordId"
			:is-income="false"
			@change="refreshTable('listTable')"
			v-if="editorVisible"
		></cash-editor>
		<batch-cash-editor
			:show.sync="editorBatchVisible"
			:batch-confirm-info="batchConfirmInfo"
			:is-income="false"
			@change="refreshTable('listTable')"
			v-if="editorBatchVisible"
		></batch-cash-editor>
	</section>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";
import FilterSupplier from "@/mixins/Filter/FilterSupplier.js";
import FilterWarehouse from "@/mixins/Filter/FilterWarehouse.js";
import FilterType from "@/mixins/Filter/FilterType.js";
import FilterPayMethod from "@/mixins/Filter/FilterPayMethod.js";
import { mapState, mapGetters, mapMutations } from "vuex";
import Cashflow from "@/mixinsApp/Cashflow.js";
import {RenderWarehouse} from "@/mixinsApp/Render";

export default {
	mixins: [
		CurdPage,
		Filters,
		FilterSupplier,
		FilterWarehouse,
		FilterType,
		FilterPayMethod,
		Cashflow,
	],

	data() {
		return {
			loadings: {
				main: false,
			},
			activeName: "list",
			baseKv: [{ k: "pay_type", t: "int", v: 1 }],
			filterConfirmed: { field: "has_confirm", value: null },
			editorDataModel: "Cashflow",

			tableFields: [
				{
					name: "show_id",
					sortable: "custom",
				},
				{
					name: "warehouse",
					sortable: "custom",
          render:RenderWarehouse
				},

				{
					name: "type",
					sortable: "custom",
				},
				{
					name: "name",
					sortable: "custom",
				},
				{
					name: "transaction",
					sortable: "custom",
					params: {
						link: "Tx-Info",
					},
				},
				{
					name: "supplier",
					sortable: "custom",
				},

				{
					name: "total_price",
					sortable: "custom",
					params: {
						isRight: true,
					},
				},
				{
					name: "pay_method",
				},
				{
					name: "has_confirm",
					needThumb: "primary_img",
				},
				{
					name: "payed_at",
					sortable: "custom",
				},
			],
		};
	},
};
</script>
